import {
  Checkbox,
  getDayAbbreviations,
  getRepetitionArrayFromRrule,
  getReptitionIntervalFromRrule,
  QuestSeries,
  Typography,
} from "@joonapp/web-shared"
import dayjs from "dayjs"
import { rrulestr } from "rrule"

import useAllQuestsMultiSelectStore from "./hooks/useAllQuestsMultiSelectStore"
import { useQuestDndSectionsStore } from "./hooks/useQuestDndSectionsStore"
import UserBadge from "../../../components/badges/userBadge/UserBadge"
import useQuestBoardStore from "../useQuestBoardStore"
import { useQuestGroupSeries } from "../useQuestGroups"

const InactiveQuestCard = ({ questSeries }: { questSeries: QuestSeries }) => {
  const { selectedUserId } = useQuestBoardStore()
  const { selectedQuestSeriesIds, toggleQuestSeriesId } =
    useAllQuestsMultiSelectStore()
  const { recurrence, reminder_time, occurrence_limit, start_date } =
    questSeries
  const { byweekday } = rrulestr(recurrence).options
  const { questGroupSeries } = useQuestGroupSeries(questSeries)
  const { userHasMadeChanges } = useQuestDndSectionsStore()

  const daysString =
    byweekday?.length === 7
      ? "Daily"
      : getDayAbbreviations(getRepetitionArrayFromRrule(recurrence))
  const frequency = getReptitionIntervalFromRrule(recurrence)

  const recurrenceText =
    occurrence_limit && start_date
      ? dayjs(start_date).format("M/D/YY")
      : `${daysString} every ${frequency > 1 ? frequency : ""} week${frequency > 1 ? "s" : ""}`
  const timeText = reminder_time ? ` at ${reminder_time}` : ""

  return (
    <div className="flex flex-row justify-between items-center border border-dashed bg-backgroundPrimary border-borderPrimary rounded-md bg-xLightGray p-3 hover:bg-bgXLightGray">
      <div className="flex flex-col">
        {recurrence || reminder_time ? (
          <Typography variant="bodyXSmall" textAlign="left">
            {recurrenceText + timeText}
          </Typography>
        ) : null}
        <Typography variant="bodySmallBold">{questSeries.title}</Typography>
        {selectedUserId === null && (
          <div className="flex flex-row gap-2 flex-wrap">
            {questGroupSeries.map((series) => (
              <UserBadge key={series.id} userId={series.user_id} />
            ))}
          </div>
        )}
      </div>

      {!userHasMadeChanges && (
        <Checkbox
          name={`quest-dnd-card-${questSeries.id}`}
          selected={selectedQuestSeriesIds.includes(questSeries.id)}
          onChange={() => toggleQuestSeriesId(questSeries.id)}
          hideBorder
        />
      )}
    </div>
  )
}

export default InactiveQuestCard
